export enum DashboardType {
    none = 0,
    pie = 1,
    bar = 2,
    donut = 3,
    column = 4
}
